import React from 'react'
import Particles from './particle'

function header() {
    return (
        <div className='particlejs'>
            <Particles />
        </div>


    )
}

export default header
